import { create } from "zustand";

const usePriceStore = create((set) => ({
  priceDetail: null, // or {} if you prefer

  // Set the entire object
  setPriceDetail: (obj) => set({ priceDetail: obj }),

  // Reset the object
  resetPriceDetail: () => set({ priceDetail: null }),
}));

export default usePriceStore;
